var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 20C35 22.9667 34.1203 25.8668 32.4721 28.3336C30.8238 30.8003 28.4811 32.7229 25.7403 33.8582C22.9994 34.9935 19.9834 35.2906 17.0737 34.7118C14.1639 34.133 11.4912 32.7044 9.3934 30.6066C7.29562 28.5088 5.86701 25.8361 5.28823 22.9264C4.70945 20.0166 5.0065 17.0006 6.14181 14.2597C7.27713 11.5189 9.19972 9.17618 11.6665 7.52796C14.1332 5.87973 17.0333 5 20 5C24.2 5 28.2167 6.66667 31.2333 9.56667L35 13.3333",
    stroke: "#6B2BD9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0003 5V13.3333H26.667",
    stroke: "#6B2BD9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconData);
export default __webpack_public_path__ + "static/media/icon-data.1fbbb745691ee1f86e83c04c10582dce.svg";
export { ForwardRef as ReactComponent };